import React, { useState } from "react";

const ProfileContext = React.createContext()


export default ProfileContext